<template>
    <div class="component-table">
        <table class="table">
            <thead
                v-if="data.table?.header?.cells?.length"
                class="head"
            >
                <tr>
                    <th
                        v-for="(cell, headerCellIndex) in data.table.header
                            .cells"
                        :key="headerCellIndex"
                        class="head-cell"
                    >
                        {{ cell }}
                    </th>
                </tr>
            </thead>

            <tbody
                v-if="data.table?.body?.rows?.length"
                class="body"
            >
                <tr
                    v-for="(
                        bodyRow, bodyRowIndex
                    ) in data.table.body.rows.filter(
                        (row) => row?.cells?.length
                    )"
                    :key="bodyRowIndex"
                    class="body-row"
                >
                    <!-- eslint-disable vue/no-v-html -->
                    <td
                        v-for="(bodyCell, cellIndex) in bodyRow?.cells || []"
                        :key="cellIndex"
                        class="body-cell"
                        v-html="localizeHrefs(bodyCell || '')"
                    ></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup lang="ts">
import type { ComponentTableFragment } from '@/graphql/api'
import { useHrefLocalizer } from '@/router/href-localizer'

defineProps<{
    data: ComponentTableFragment
}>()

const localizeHrefs = useHrefLocalizer()
</script>

<style lang="scss" scoped>
.component-table {
    width: 100%;
    padding: 20px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    .table {
        border: 1px solid $stone;
        width: 100%;
        font-family: $effra-font-stack;
        letter-spacing: 0.125rem;
        font-weight: 400;
        font-size: 0.875rem;
        line-height: 1.2em;

        .head {
            .head-cell {
                background: $stone-2;
                padding: 20px 10px;
                font-weight: 600;
            }
        }

        .body {
            .body-row {
                .body-cell {
                    background: $stone-3;
                    border-bottom: 1px solid $stone;
                    padding: 20px 10px;
                }

                &:last-child {
                    .body-cell {
                        border-bottom: none;
                    }
                }
            }
        }
    }
}
</style>
